/**
 * How often a page asks again while work it started runs in the background: a
 * document import or a RUMI run, each a workflow the API only starts.
 */
export const BACKGROUND_POLL_MS = 5_000;
